import { APP_URL } from "../data/content";

export default function CtaBanner({ title, subtitle, btnText, onClick }) {
  // If onClick is provided it's a button (internal nav), otherwise it's an external link
  return (
    <div className="cta-box">
      <h2>{title}</h2>
      <p>{subtitle}</p>
      {onClick ? (
        <button className="cta-box-btn" onClick={onClick}>{btnText}</button>
      ) : (
        <a href={APP_URL} target="_blank" rel="noopener noreferrer" className="cta-box-btn">
          {btnText}
        </a>
      )}
    </div>
  );
}
